/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import { JSX } from "react";
import { Link } from "./Link";

interface Props {
  className?: string;
}

export const YT = ({ className }: Props): JSX.Element => {
  return (
    <Link
      href="https://www.youtube.com/@LongPole"
      aria-label="Watch LongPole on YouTube"
      target="_blank"
      rel="noreferrer"
    >
      <svg
        className={`${className}`}
        aria-hidden="true"
        fill="none"
        height="33"
        viewBox="0 0 34 33"
        width="34"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9424 13.026L21.0783 16.5129L14.9424 19.9998V13.026ZM31.7775 5.15625V27.8438C31.7775 29.5518 30.3918 30.9375 28.6838 30.9375H5.99628C4.28827 30.9375 2.90253 29.5518 2.90253 27.8438V5.15625C2.90253 3.44824 4.28827 2.0625 5.99628 2.0625H28.6838C30.3918 2.0625 31.7775 3.44824 31.7775 5.15625ZM29.0705 16.5193C29.0705 16.5193 29.0705 12.6779 28.5807 10.8346C28.3099 9.81621 27.5172 9.01699 26.5053 8.74629C24.6812 8.25 17.34 8.25 17.34 8.25C17.34 8.25 9.99882 8.25 8.17479 8.74629C7.16288 9.01699 6.3701 9.81621 6.0994 10.8346C5.60956 12.6715 5.60956 16.5193 5.60956 16.5193C5.60956 16.5193 5.60956 20.3607 6.0994 22.2041C6.3701 23.2225 7.16288 23.9895 8.17479 24.2602C9.99882 24.75 17.34 24.75 17.34 24.75C17.34 24.75 24.6812 24.75 26.5053 24.2537C27.5172 23.983 28.3099 23.216 28.5807 22.1977C29.0705 20.3607 29.0705 16.5193 29.0705 16.5193Z"
          fill="white"
        />
      </svg>
    </Link>
  );
};
